import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ISaveCard } from '../types/CardList';
import { userCardAPI } from '../api/userCardAPI';
import { custonSooner } from '../../../components/CustopmSooner';
import { captureApiError, captureError } from '../../../lib/sentry-utils';

export const useConfirmCard = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (body: ISaveCard) => {
      try {
        const res = await userCardAPI.confirm(body);
        if (!res.data.success) {
          captureError(res.data.message || 'Failed to confirm card', {
            endpoint: '/api/user-card/confirm',
            cardData: {
              cardId: body.id,
            },
            responseData: {
              success: res.data?.success,
              message: res.data?.message,
              error: res.data?.error,
            },
          });
        }
        return res;
      } catch (error) {
        console.error('ConfirmCard error:', {
          message: error instanceof Error ? error.message : String(error),
          status: (error as any)?.response?.status,
          statusText: (error as any)?.response?.statusText,
          data: (error as any)?.response?.data
            ? {
                success: (error as any).response.data.success,
                message: (error as any).response.data.message,
                error: (error as any).response.data.error,
              }
            : undefined,
        });
        captureApiError(error, '/api/user-card/confirm', 'POST');
        throw error;
      }
    },
    onSuccess: (res) => {
      if (res.data.success) {
        queryClient.invalidateQueries({ queryKey: ['card-list'] });
        custonSooner.success('Карта успешно подтверждена!');
      } else {
        custonSooner.error(res.data.message);
      }
    },
    onError: error => {
      console.error('ConfirmCard mutation error:', {
        message: error instanceof Error ? error.message : String(error),
        status: (error as any)?.response?.status,
        statusText: (error as any)?.response?.statusText,
        data: (error as any)?.response?.data
          ? {
              success: (error as any).response.data.success,
              message: (error as any).response.data.message,
              error: (error as any).response.data.error,
            }
          : undefined,
      });
      captureApiError(error, '/api/user-card/confirm', 'POST');
    },
  });
  return {
    confirmCard: mutateAsync,
    isPending,
  };
};
